<template>
  <div class="login-wrap">
    <div class="login-inner">
      <el-card class="box-card">
        <img src="@/assets/images/logo.png" alt="">
        <div class="login-title">超本乐出货管理系统</div>
        <el-form :model="loginForm" status-icon ref="loginForm" :rules="rulesLogin">
          <el-form-item prop="username">
            <el-input @keyup.enter.native="submitForm('loginForm')" placeholder="请输入账号" type="text" v-model="loginForm.username" auto-complete="on">
              <template slot="prepend"><i class="el-icon-message"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input @keyup.enter.native="submitForm('loginForm')" placeholder="请输入密码" type="password" v-model="loginForm.password" auto-complete="on">
              <template slot="prepend"><i class="el-icon-view"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="login-bottom">
      <p>© Copyright 2016-2018 creekspring</p>
    </div>
  </div>
</template>

<script>
import '@/assets/stylus/login.styl';
import axios from 'axios';
import http from 'http';

export default {
  data () {
    return {
      shipmentUser: [],
      monitorUser: [],
      loginForm: {
        username: '',
        password: ''
      },
      rulesLogin: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 16, message: '密码要求6~16个字符', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 获取配置信息
    async getConfigInfo () {
      let { data: {shipmentUser, monitorUser} } = await axios.get('/static/config/users.json', {
        baseURL: ''
      });
      this.shipmentUser = shipmentUser;
      this.monitorUser = monitorUser;
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { data } = await http.post('/v1/auth/login', this.loginForm);
          if (data.code === 200) {
            this.$store.commit('updateToken', data.detail);
            sessionStorage.setItem('token', data.detail);
            sessionStorage.setItem('userInfo', JSON.stringify(data.user));
            if (this.monitorUser.includes(data.user.username)) {
              this.$router.push({name: 'monitor'});
            } else {
              if (this.shipmentUser.includes(data.user.username)) {
                this.$router.push({name: 'shipment'});
              } else {
                this.$router.push({name: 'sale'});
              }
            }
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created () {
    this.getConfigInfo();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/login/index.vue